import { SIDEBAR_COLOR } from "./colorsManager";

export const OutlinedButtonStyles = {
  border: `1px solid ${SIDEBAR_COLOR}`,
  backgroundColor: "white",
  width: 120,
};

export const ButtonStyles = {
  border: `0px solid ${SIDEBAR_COLOR}`,
  backgroundColor: SIDEBAR_COLOR,
};
